/**
 * Group FAQs collapsible accordion.
 *
 * Markup contract (per `Views/Partials/blocklist/Components/groupFaqsSection.cshtml`,
 * 1:1 port of legacy `Views/CmsBlog/Partial/FaqsList.cshtml`):
 *
 *   <div class="collapsible js-collapsible collapsed">
 *     <h3 class="js-collapsible-toggle">
 *       <span>... question ...</span>
 *       <a class="btn-toggle">Expand / Collapse</a>
 *     </h3>
 *     <div class="collapsible-content js-collapsible-content" style="display: none;">
 *       ... answer ...
 *     </div>
 *   </div>
 *
 * Behavior: click `.js-collapsible-toggle` → toggle `.collapsed` class on the
 * `.js-collapsible` wrapper + show/hide `.js-collapsible-content`. First-paint
 * is collapsed (matches legacy first-paint state — the Razor markup writes
 * `style="display: none;"` inline).
 *
 * Each FAQ is independent — multiple can be open simultaneously (matches
 * legacy behavior where clicking different questions doesn't auto-close
 * others).
 */

const WRAPPER = '.js-collapsible';
const TOGGLE = '.js-collapsible-toggle';
const CONTENT = '.js-collapsible-content';
const COLLAPSED_CLASS = 'collapsed';

export function initFaqAccordion(): void {
    const wrappers = document.querySelectorAll<HTMLElement>(WRAPPER);
    wrappers.forEach(wrapper => {
        const toggle = wrapper.querySelector<HTMLElement>(TOGGLE);
        const content = wrapper.querySelector<HTMLElement>(CONTENT);
        if (!toggle || !content) {
            return;
        }
        toggle.addEventListener('click', () => {
            const willCollapse = !wrapper.classList.contains(COLLAPSED_CLASS);
            wrapper.classList.toggle(COLLAPSED_CLASS, willCollapse);
            content.style.display = willCollapse ? 'none' : '';
        });
    });
}
